import { ChangeDetectorRef, Directive, HostBinding, Input, inject, model } from '@angular/core';

@Directive({
  selector: '[hideable]',
  standalone: true,
})
export class HideableDirective {
  protected _changeDetector = inject(ChangeDetectorRef);

  private _isVisible: boolean = true;
  @Input() set isVisible(v: boolean) {
    this._isVisible = v;
  }
  get isVisible(): boolean {
    return this._isVisible;
  }

  readonly initialDisplayStyle = model<'initial' | 'block' | 'flex'>('initial');
  @HostBinding('style.display') get getHideableStyle() {
    return this._isVisible ? this.initialDisplayStyle() : 'none';
  }

  constructor(changeDetector?: ChangeDetectorRef) {
    if (changeDetector) {
      this._changeDetector = changeDetector;
    }
  }
}
